import { environment } from "environments/environment";
import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType } from "@azure/msal-browser";

// Scope del API expuesto (App Registration del backend). Igual en test y prod.
const API_SCOPE = 'api://5f8a9565-b218-493f-83e6-94e212131ab5/.default openid profile';

export default function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>([
        ['https://graph.microsoft.com/v1.0/me', ['User.Read']],
        // Se deriva de apiEndPoint (runtime): funciona en local, test y prod sin hardcodear.
        [`${environment.apiEndPoint}/*`, [API_SCOPE]],
    ]);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}
